import { useEffect, useState } from 'react';
import { formatearCOP } from '@tanteo/compartido';
import { obtenerSemaforo, type Semaforo } from '../../lib/api-config';
import { Insignia, Tarjeta } from '../../ui/base';
import { instalacion } from '@tanteo/compartido/instalacion';

/** Los ingresos del año contra el umbral que suele obligar a facturar electrónicamente. */
export function SeccionSemaforo({ negocioId }: { negocioId: string }) {
  const [semaforo, setSemaforo] = useState<Semaforo | null>(null);

  useEffect(() => {
    void obtenerSemaforo(negocioId).then(setSemaforo);
  }, [negocioId]);

  return (
    <Tarjeta>
      <h2 className="mb-2 font-extrabold">Semáforo de formalización</h2>
      {semaforo === null ? (
        <p className="text-muted text-contenido">Sin datos aún.</p>
      ) : (
        <div className="space-y-2">
          <p>
            {semaforo.estado === 'verde' && <Insignia tono="exito">VERDE</Insignia>}
            {semaforo.estado === 'amarillo' && <Insignia tono="aviso">AMARILLO</Insignia>}
            {semaforo.estado === 'rojo' && <Insignia tono="peligro">ROJO</Insignia>}
            {semaforo.estado === 'sin_uvt' && <Insignia tono="neutro">SIN UVT DEL AÑO</Insignia>}
            <span className="num ml-2 font-bold">{formatearCOP(semaforo.ingresosAnio)}</span>
            {semaforo.umbralCop && <span className="text-muted"> de {formatearCOP(semaforo.umbralCop)} (3.500 UVT)</span>}
          </p>
          {/* El semáforo explica el umbral que obliga a facturar: nombrarlo es el punto. */}
          {/* eslint-disable-next-line no-restricted-syntax */}
          <p className="text-muted text-contenido">
            Vigila los ingresos del año contra el umbral que suele obligar a facturar electrónicamente. También cuentan:
            consignaciones bancarias, un segundo local, franquicias o entrar al régimen SIMPLE — esos revísalos con tu
            contador. {instalacion.nombre} no presta asesoría tributaria.
          </p>
        </div>
      )}
    </Tarjeta>
  );
}
